import { useEffect, useState } from 'react';
import { SignJWT } from 'jose';

const Dashboard = () => {
	const [token, setToken] = useState({});

	const iframesData = [
		{
			embed_code: '7ad39054890a978c696c9787',
			secret_key:
				'ee3f7f48b44537cf8549af3d1396b4d58878e820615308acfee6a6f6f7df95901c237f75f7e960afefce2aa8511045210aa28454c3eb38f7db934c2c4bc63e81',
		},
		{
			embed_code: 'f529de9aec115473dc5ed402',
			secret_key:
				'9bb8a998a58fe853ef58b762cb8d6415e5ffc1711d0d25b96a815c8a7220693b5c445544921ffbe091baafa8d7526d3a855d3a762f69014d86c110fdea5fb704',
		},
	];

	useEffect(() => {
		const generateToken = async () => {
			for (const iframe of iframesData) {
				const { embed_code, secret_key } = iframe;

				const payload = {
					iat: Math.floor(Date.now() / 1000),
					settings: {
						enable_export_data: false,
						default_timezone: null,
						hide_timezone: true,
						allow_to_change_timezone: false,
						hide_header_panel: true,
						allow_dashboard_export: false,
						allow_raw_data_export: false,
						allow_dashboard_timezone_change: false,
						hide_dashboard_filters_controls_panel: true,
						hide_toolbar: true,
						allow_toolbar: false,
					},
					permissions: {
						row_based: [],
					},
					filters: {},
					embed_code,
				};

				const secret = new TextEncoder().encode(secret_key);

				const jwt = await new SignJWT(payload).setProtectedHeader({ alg: 'HS256' }).sign(secret);

				setToken((prevTokens) => ({
					...prevTokens,
					[embed_code]: jwt,
				}));
			}
		};

		generateToken();
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	if (!token) return <p>Loading...</p>;

	return (
		<div className="megaContent">
			{
				<>
					{iframesData.map((iframe, index) => {
						const iframeUrl = `https://eu.holistics.io/embed/${iframe.embed_code}?_token=${token[iframe.embed_code]}`;
						return (
							<iframe
								key={index}
								src={iframeUrl}
								id={`embedded-iframe-${index}`}
								allowFullScreen
								title={`title-${iframe.embed_code}`}
								style={{ width: '100%', height: '400px', marginBottom: '20px', marginBlock: '24px 28px', paddingBlock: '3px' }}
							/>
						);
					})}
				</>
			}
		</div>
	);
};

export default Dashboard;
